import { HalfContainer } from "common/common.styled";
import Button from "components/Button";
import Grid from "components/Grid";
import Text from "components/Text";
import { FC } from "react";
import { IconContext } from "react-icons";
import { BiLoaderAlt } from "react-icons/bi";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import {
    JobPurposeWrapper,
    LoaderContainer,
    NoDataText,
    PurposeOptions,
} from "./JobPurpose.styled";
import { useJobPurpose } from "./useJobPurpose";

export const JobPurpose: FC = () => {
    const {
        isFetching,
        options,
        handleJobPurposeChange,
        selectedOption,
        handleBack,
        handleNext,
    } = useJobPurpose();

    return (
        <JobPurposeWrapper>
            <HalfContainer>
                <Text variant="heading5">What is your purpose?</Text>
                {isFetching && (
                    <IconContext.Provider value={{ className: "loader" }}>
                        <LoaderContainer>
                            <BiLoaderAlt />
                        </LoaderContainer>
                    </IconContext.Provider>
                )}
                {options.length > 0 && (
                    <PurposeOptions
                        value={selectedOption}
                        label=""
                        options={options}
                        columns={3}
                        onChange={handleJobPurposeChange}
                    />
                )}
                {!isFetching && options.length === 0 && (
                    <NoDataText>No Data Found.</NoDataText>
                )}
                <Grid marginTop={3} columnGap={1}>
                    <Button
                        type="button"
                        variant="outlined"
                        icon={<BsArrowLeft />}
                        iconPosition="prefix"
                        onClick={handleBack}
                    >
                        Back
                    </Button>
                    <Button
                        type="button"
                        variant="filled"
                        icon={<BsArrowRight />}
                        iconPosition="suffix"
                        disabled={selectedOption === ""}
                        onClick={handleNext}
                    >
                        Next
                    </Button>
                </Grid>
            </HalfContainer>
        </JobPurposeWrapper>
    );
};
